import { EditableCellInfo } from "@/stores/editableData";

export const makeCellDomId = (payload: EditableCellInfo) => {
  const { rowUuid, columnUuid } = payload;
  return `cell-${rowUuid}-${columnUuid}`;
};
